/**
 * PowerSavingSwitcherContainer component.
 */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';

/**
 * Styled power saving switcher container.
 */
const PowerSavingSwitcherContainer = styled.div<React.CSSProperties>`
  margin-left: ${120 * Screen.widthRatio}px;
`;

export default PowerSavingSwitcherContainer;
